import {
  APPROVAL_POLICY_MUTATION,
  USER_GROUP_MUTATION,
} from '@services/permissions'

import type { Section } from '../types'

export const approvalSettingsGroupSection: Section = {
  label: 'layout:page.approvalSettings.group.title',
  route: '/settings/approval-settings/groups',
  // Note: Only users with mutation permissions can view the page. Viewing access is restricted to those who can modify it.
  permissions: USER_GROUP_MUTATION,
  segment: {
    page: 'Approval Settings - Group',
  },
}

export const approvalSettingsSection: Section = {
  label: 'layout:page.approvalSettings.title',
  route: '/settings/approval-settings',
  tabLabel: 'layout:page.approvalSettings.accountOperations.title',
  // Note: Only users with mutation permissions can view the page. Viewing access is restricted to those who can modify it.
  permissions: APPROVAL_POLICY_MUTATION,
  segment: {
    page: 'Approval Settings - Account Operations',
  },
  pages: [approvalSettingsGroupSection],
}
